import React from 'react';
import { dateFormat, textfieldDateFormat } from "../../../utils/dateFunctions";
import MUIDataTable from "mui-datatables";
import { CircularProgress } from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import { tableTheme } from '../../../themes/tableTheme';
import { adalApiFetch } from '../../../../adalConfig';
import DataTableStandard from "../../../components/DataTableStandard";
import { getAPIData } from '../../../utils/apiFunction';


const SupplierPricing = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    const [loading, setLoading] = React.useState(false);
    const [columns, setColumns] = React.useState([]);
    const [procurement, setProcurement] = React.useState([]);
    const [stockItems, setStockItems] = React.useState([]);
    
    React.useEffect(() => {
        if (stockItems.length > 1) {

        var cols = [
            {
                name: 'name',
                label: 'Name',
                options: props.farmerFilter ? { filterList: [props.farmerFilter] } : {}
            },
        ]
            cols = [...cols, ...stockItems.filter((si) => {
                return procurement.find((pc) => { console.log(pc, si); return pc[si.description]?true:false  });
            }).map((si) => {
                return {
                    name: si.description,
                    label: si.description,
                    options: {
                        filter: false
                    }
                }
            })];

        setColumns(cols);
        }
    }, [stockItems,procurement])

    const options = {
        filterType: 'dropdown',
        selectableRowsHideCheckboxes: true,
        fixedHeader: true,
        tableBodyMaxHeight: '800px',
        responsive: 'standard',
        onRowClick: props.onClick ? props.onClick(procurement) : (() => { }),
        rowsPerPage: 1000,

    };
    React.useEffect(() => {
        getAPIData('/StockItems/GetProcessed', setStockItems);
        setProcurement([]);
        getProcurementData();
    }, [props.reload]);

    var getProcurementData = async () => {
        setLoading(true);
        const response = await adalApiFetch(fetch, uri + '/CustomerPricing/Get');
        const data = await response.json();
        console.log(data)
        var supps = {};
        for (var i = 0; i < data.length; i++) {
            if (supps[data[i].customerId]) {
                supps[data[i].customerId].push(data[i]);
            } else {
                supps[data[i].customerId] = [data[i]];
            }
        }
        var suppArr = [];
        var arrInd = 0;
        for (const [key, value] of Object.entries(supps)) {
            for (var i = 0; i < value.length; i++) {
                if (i == 0) {
                    suppArr[arrInd] = { name: value[i].customer?.name, detail: value, customerId: value[i].customerId };
                }
                suppArr[arrInd][value[i].stockItem?.description] = value[i].price;
            }
            arrInd++;
        }

        console.log(suppArr)
        setLoading(false);
        setProcurement(suppArr);
    }
    return (
        <DataTableStandard
            data={props.filter ? props.filter(procurement) : procurement}
            title={"Customer Pricing"}
            columns={columns}
            options={options}
            returnSearch={!loading}
            reload={props.reload}
            shrink={true}
        />
    );
};

export default SupplierPricing;
